<section class="py-i w-100">
    <div class="text-c mb-i">
        <p>Distribuidora Nissan S.A. Colombia</p>
    </div>
    <div class="box">
        <a href="https://api.whatsapp.com/send?phone=573022630685&text=Hola%2C%20estoy%20realizando%20una%20compra%20por%20la%20tienda%20online%20de%20posventa" target="_blank" class="btn" style="background: #000">
            <div class="box sx-i">
                <img height="18" src="/static/storefront/pix/icons/whatsapp-blanco.svg" alt="whatsapp">
                <div class="white">Whatsapp: +57 302 263 0685</div>
            </div>
        </a>
    </div>
</section>